// import node module classes
import React, { useState, useEffect, useRef } from "react" // Added React for memo optimization
//GeoLocate
import { useGeolocated } from "react-geolocated";
import { getDistance } from "geolib"; // Import getDistance from geolib

//bootstrap
import Nav from 'react-bootstrap/Nav'
import { Modal, Button } from "react-bootstrap"
import Navbar from 'react-bootstrap/Navbar'
import Container from 'react-bootstrap/Container'

//Components
import QRCode from 'react-qr-code';
import Address from "./components/Address"
import Calendar from "./components/Calendar"
import Login from "./entry/Login"
import SignUp from "./entry/SignUp"
import Admin from "./help/admin"
import BarAdmin from "./help/barAdmin"
import About from "./help/about"
import QuickPayment from "./components/QuickPayment";
import XMembers, { UpdateProfile } from './components/XMembers';
import ClubAccess from "./components/ClubAccess";
import XDocz from './components/XDocz';
import XMenu from "./components/XMenu";
import Incidentz from './components/Incidentz';
import XLinkz from "./components/XLinkz";
import XVideoz from './components/XVideoz';
import XArtist from "./components/XArtist";
import EventSuite from './components/EventSuite';
import AccessVitals from "./components/AccessVitals";
import './components/XDocList';

//toast
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import "typeface-quicksand"

// import firebase
import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
  doc,
  updateDoc, // Added updateDoc for checking out
  query,
  where,
  limit,
  orderBy,
  Timestamp
} from 'firebase/firestore'
import { auth, messaging } from "./utils/firebase"
import { signOut } from "firebase/auth"
import { onAuthStateChanged } from "firebase/auth";
import { getToken, onMessage } from "firebase/messaging";

// import images
import target from "./images/target.png"
import thumb from "./images/thumb.png"
import thumb2 from "./images/thumb2.png"
import { FaArrowUp } from 'react-icons/fa';
import sun from "./images/sun.png"
import moon from "./images/moon.png"
// import custom classes and functions
import { spinner, checkEmpty } from "./utils/Helper"
import InteractiveVideo from "./components/InteractiveVideo";

// PERFORMANCE ENGINE EXCLUSION: Memoize calendar component structure to drop all parent re-renders caused by GPS metrics updates
const OptimizedCalendarSection = React.memo(function OptimizedCalendarSection() {
  return <Calendar />;
});

export default function MainBody(props) {
  const [xState, setXState] = useState(0);
  const [show, setShow] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [showRegister, setShowRegister] = useState(false);;
  const [user, setUser] = useState('');
  const [userProfile, setUserProfile] = useState(false);
  const [accountFlag, setAccountFlag] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [hasIncident, setHasIncident] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [daysLeft, setDaysLeft] = useState(0);
  const [userDisp, setUserDisp] = useState('');
  const [profileItems, setProfileItems] = useState([]);
  const [isVisible, setIsVisible] = useState(true);
  const [theme, setTheme] = useState(localStorage.getItem('app-theme') || 'dark');
  const [BGCal, setBGCal] = useState(theme === 'dark' ? 'blacx' : 'lightx');
  const [BGHeader, setBGHeader] = useState(theme === 'dark' ? 'navDark' : 'navLight');
  const [isAdmin, setIsAdmin] = useState(false);
  const [isBarAdmin, setIsBarAdmin] = useState(false);
  const [accessItems, setAccessItems] = useState([]);
  const [distanceToClub, setDistanceToClub] = useState(0);
  //Club target range within meters
  const [clubTargetRange, setClubTargetRange] = useState(60);
  const [refreshKey, setRefreshKey] = useState(0);
  const [showQR, setShowQR] = useState(false);
  const handleCloseQR = () => setShowQR(false);
  const handleShowQR = () => setShowQR(true);

  // Track retrieved membership metadata metrics safely across views
  const [lateFee, setLateFee] = useState(0);
  const [amount, setAmount] = useState(0);

  // Global toast debounce tracking ref across component loops
  const toastDebounceRef = useRef(false);

  // PRODUCTION FIX: Evaluates precisely whether the user has checked out by checking for a non-null checkedOutAt timestamp
  const hasNotCheckedInToday = accessItems?.length === 0 || !!accessItems[0]?.checkedOutAt;

  // Call when access log is created to refresh and show access log 
  const handleParentAccessLogChange = () => {
    setRefreshKey(prev => prev + 1);
  };

  // Persist the theme whenever it changes
  useEffect(() => {
    localStorage.setItem('app-theme', theme);
    setBGCal(theme === 'dark' ? 'blacx' : 'lightx');
    setBGHeader(theme === 'dark' ? 'navDark' : 'navLight');

    // Optional: Apply a class to the body for global CSS targeting
    document.body.className = theme + '-theme';
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  const db = getFirestore();
  //log Access 


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth animation
    });
  }

  //Start

  async function requestPermission() {
    //requesting permission using Notification API
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_VAPID_KEY
      });
      //We can send token to server
      console.log("Token generated : ", token);
    } else if (permission === "denied") {
      //notifications are blocked
      alert("You denied for the notification");
    }
  }


  useEffect(() => {

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // --- AUTH FIX ---
        // Ensure the display name is synced for the Header
        const nameToDisplay = user.displayName || user.email || "Member";
        setUserDisp(nameToDisplay);

        // Sync Storage for the Payment Modal
        localStorage.setItem("uid", user.uid);
        localStorage.setItem("user", nameToDisplay);
        localStorage.setItem("userName", nameToDisplay);
        localStorage.setItem("email", user.email);
        localStorage.setItem("userEmail", user.email);
        localStorage.setItem("isAnon", user.isAnonymous);
        sessionStorage.setItem("email", user.email);

        setUser(user.isAnonymous);
        getProfileDoc();

      } else {
        // RESET ON LOGOUT
        localStorage.setItem("email", "Login");
        localStorage.setItem("userEmail", "");
        localStorage.setItem("userName", "");
        localStorage.setItem("isAnon", true);
        localStorage.setItem("user", "Guest");
        localStorage.setItem("uid", "");
        localStorage.setItem("expirationDate", "");
        localStorage.setItem("isExpired", "");
        localStorage.setItem("type", "");
        sessionStorage.removeItem("email");

        setUser(true);
        setUserDisp("login");
        setIsAdmin(false);
        setIsBarAdmin(false);
      }

      const email = localStorage.getItem('email');
      if (email && email !== "Login") {
        getAccessDoc(email);
      }
    });

    onMessage(messaging, (payload) => {
      console.log('Message received in foreground: ', payload);
      toast.info(payload.notification.title, { autoClose: false, });
    });

    return () => unsubscribe();

  }, [xState])

  const getLogsCollectionName = (date = new Date()) => {
    const year = date instanceof Date ? date.getFullYear() : new Date().getFullYear();
    return `access_logs_${year}`;
  };


  const getAccessDoc = async (identifier) => {
    if (!identifier) return;
    const logsRef = collection(db, getLogsCollectionName());

    // PERFECT NIGHTLIFE OPERATIONAL WINDOW LOGIC
    const startOfWindow = new Date();
    const endOfWindow = new Date();

    if (startOfWindow.getHours() < 2) {
      // Late night (12 AM - 2 AM): Bound to yesterday's shift starting exactly at 2:00 AM
      startOfWindow.setDate(startOfWindow.getDate() - 1);
      startOfWindow.setHours(2, 0, 0, 0);
      endOfWindow.setHours(2, 0, 0, 0);
    } else {
      // Business hours: Bound strictly to today's shift from 2:00 AM today to 2:00 AM tomorrow morning
      startOfWindow.setHours(2, 0, 0, 0);
      endOfWindow.setDate(endOfWindow.getDate() + 1);
      endOfWindow.setHours(2, 0, 0, 0);
    }

    try {
      spinner(true);
      
      // 1. Check raw payload identity match
      let qMember = query(
        logsRef,
        where("rawPayload", "==", identifier),
        where("scannedAt", ">=", Timestamp.fromDate(startOfWindow)),
        where("scannedAt", "<=", Timestamp.fromDate(endOfWindow)),
        orderBy("scannedAt", "desc"),
        limit(1)
      );
      let snapMember = await getDocs(qMember);

      // 2. Check lowercased string variant fallback
      if (snapMember.empty && identifier.toLowerCase() !== identifier) {
        qMember = query(
          logsRef,
          where("rawPayload", "==", identifier.toLowerCase()),
          where("scannedAt", ">=", Timestamp.fromDate(startOfWindow)),
          where("scannedAt", "<=", Timestamp.fromDate(endOfWindow)),
          orderBy("scannedAt", "desc"),
          limit(1)
        );
        snapMember = await getDocs(qMember);
      }

      // 3. Check plain Display Name fallback string text match
      const cachedName = localStorage.getItem("user");
      if (snapMember.empty && cachedName) {
        qMember = query(
          logsRef,
          where("rawPayload", "==", cachedName),
          where("scannedAt", ">=", Timestamp.fromDate(startOfWindow)),
          where("scannedAt", "<=", Timestamp.fromDate(endOfWindow)),
          orderBy("scannedAt", "desc"),
          limit(1)
        );
        snapMember = await getDocs(qMember);
      }

      if (!snapMember.empty) {
        const docData = snapMember.docs[0].data();
        setAccessItems([{
          id: snapMember.docs[0].id,
          ...docData,
        }]);
      } else {
        setAccessItems([]);
      }
    } catch (e) {
      console.error("Query Error:", e);
    } finally {
      spinner(false);
    }
  };

  /**
   * SILENT TIME-BASED SHIFT WINDOW EXPIRATION HEARTBEAT GUARD
   */
  useEffect(() => {
    const verifyShiftWindowExpiration = () => {
      if (accessItems?.length === 0 || !!accessItems[0]?.checkedOutAt) {
        return;
      }

      const now = new Date();
      const scannedAtTimestamp = accessItems[0]?.scannedAt;
      if (!scannedAtTimestamp) return;

      const checkInDate = scannedAtTimestamp.toDate ? scannedAtTimestamp.toDate() : new Date(scannedAtTimestamp);

      const startOfWindow = new Date();
      if (startOfWindow.getHours() < 2) {
        startOfWindow.setDate(startOfWindow.getDate() - 1);
        startOfWindow.setHours(2, 0, 0, 0);
      } else {
        startOfWindow.setHours(2, 0, 0, 0);
      }

      if (checkInDate < startOfWindow) {
        console.log("Silent Expiration Engine -> Stale operational shift log caught. Resetting active elements.");
        setAccessItems([]);
      }
    };

    verifyShiftWindowExpiration();
    const shiftTrackerInterval = setInterval(verifyShiftWindowExpiration, 30000);

    return () => clearInterval(shiftTrackerInterval);
  }, [accessItems]);

  const LocationDistanceCalculator = ({
    setDistanceToClub,
    accessItems,
    handleChildAccessClub
  }) => {

    const email = localStorage.getItem('email');
    const isUserLoggedIn = email && email !== "Login";

    // --- TESTING TOGGLE ---
    const USE_MY_LOCATION = false

    // Albuquerque default test coords
    const myCurrentTestCoords = {
      latitude: 30.238974634010255,
      longitude: -84.23107125147551
    };

    const pressClubCoords = {
      latitude: 35.081747,
      longitude: -106.639145,
    };

    const targetLocation = USE_MY_LOCATION ? myCurrentTestCoords : pressClubCoords;

    const { coords, isGeolocationAvailable } = useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
        maximumAge: 60000,
        timeout: Infinity,
      },
      userDecisionTimeout: 5000,
      watchPosition: true,
      suppressLocationOnMount: false,
    });

    const distance = coords
      ? getDistance(
        { latitude: coords.latitude, longitude: coords.longitude },
        targetLocation
      )
      : null;

    // SAFE UPDATE + BREAK INFINITE RE-RENDER LOOP
    useEffect(() => {
      if (distance !== null && typeof setDistanceToClub === 'function' && isUserLoggedIn) {
        setDistanceToClub((prevDistance) => {
          if (Math.abs(prevDistance - distance) > 100) {
            return distance;
          }
          return prevDistance;
        });
      }
    }, [distance, setDistanceToClub, isUserLoggedIn]);

    // GEOLOCATION AUTOMATIC LOGICAL OUTBOUND CHECK-OUT + FIRESTORE UPDATE
    useEffect(() => {
      const performGeofencedCheckout = async () => {
        if (!accessItems || accessItems.length === 0 || !!accessItems[0]?.checkedOutAt) {
          return;
        }

        if (distance !== null && distance > clubTargetRange) {
          if (toastDebounceRef.current) return;
          
          toastDebounceRef.current = true;
          const targetLogId = accessItems[0].id;

          setAccessItems([]);
          toast.info("You have moved away from the club. Auto checked-out.");

          if (targetLogId) {
            try {
              const logDocRef = doc(db, getLogsCollectionName(), targetLogId);
              await updateDoc(logDocRef, {
                checkedOutAt: Timestamp.now()
              });
            } catch (error) {
              console.error("Error writing checkout timestamp to Firestore:", error);
            } finally {
              setTimeout(() => {
                toastDebounceRef.current = false;
              }, 5000);
            }
          } else {
            toastDebounceRef.current = false;
          }
        }
      };

      performGeofencedCheckout();
    }, [distance, accessItems]);

    useEffect(() => {
      if (!isGeolocationAvailable) {
        toast.error("Your browser does not support Geolocation");
      }
    }, [isGeolocationAvailable]);

    // SCENARIO RULE 1: If active access log exists matching current window hours, hide entire calculator area completely
    if (!hasNotCheckedInToday) {
      return null;
    }

    // SCENARIO RULE 2: User doesn't have active log -> Checks for Geolocation coords and matches Range boundaries
    if (coords && (distance <= clubTargetRange)) {
      return isUserLoggedIn ? (
        <div className="check-in-section">
          {/* User is in range on geolocation -> displays self check-out interface */}
          <ClubAccess
            onSendToParent={handleChildAccessClub}
            memberName={userDisp || email}
            memberEmail={email}
          />
        </div>
      ) : null;
    }

    // SCENARIO RULE 3: User doesn't have active log -> Geolocation missing OR Outside range -> displays manual check-in box
    return isUserLoggedIn ? (
      <div className="check-in-section">
        <div className="d-inline-flex align-items-center justify-content-center flex-column scan-stabilizer-box" style={{ minWidth: '62px', minHeight: '62px' }}>
          <div className="image-focus-wrapper hoverX" onClick={handleShowQR}>
            <QRCode value={email} size={50} className="" bgColor="transparent" fgColor={"#0b0b0b"} level="M" />
          </div>
          <span className="orange"><small>Club Access</small></span>
        </div>
      </div>
    ) : null;

  };

  const getProfileDoc = async () => {
    spinner(true);
    const db = getFirestore();
    const ref = collection(db, "profiles");

    try {
      const currentEmail = localStorage.getItem('email');
      if (!currentEmail || currentEmail === "Login") {
        spinner(false);
        return;
      }

      const q = query(ref, where('email', "==", currentEmail));
      const querySnapshot = await getDocs(q);
      const accessProfile = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setProfileItems(accessProfile);

      if (accessProfile.length > 0 && !checkEmpty(accessProfile[0].email)) {
        const profile = accessProfile[0];
        setUserProfile(true);

        const localHasIncident = !!profile.hasIncident;
        const localIsMember = !!profile.member;
        let localIsExpired = false;

        setHasIncident(localHasIncident);
        setIsMember(localIsMember);

        const finalName = profile.name || localStorage.getItem('user');
        localStorage.setItem("user", finalName);
        setUserDisp(finalName);

        localStorage.setItem("expirationDate", profile.expirationDate);
        localStorage.setItem("type", profile.type);
        localStorage.setItem("uid", profile.id);

        try {
          const membershipTypeName = profile.type;

          if (membershipTypeName) {
            const levelRef = doc(db, "membership_levels", membershipTypeName);
            const levelSnap = await getDoc(levelRef);

            if (levelSnap.exists()) {
              const levelData = levelSnap.data();

              if (levelData.lateFee !== undefined) setLateFee(levelData.lateFee);
              if (levelData.cost !== undefined) setAmount(levelData.cost);

              if (levelData.account_flag === true) {
                setAccountFlag(true);
              } else {
                setAccountFlag(false);
              }
            }
          }
        } catch (error) {
          console.error("Error in getDocProfile membership metadata:", error);
        }

        if (profile.expirationDate) {
          const now = new Date();
          const expD = profile.expirationDate.toDate
            ? profile.expirationDate.toDate()
            : new Date(profile.expirationDate);

          if (expD < now) {
            localIsExpired = true;
            setDaysLeft(0);

            if (!localIsMember) {
              localIsExpired = false;
              setIsExpired(false);
              setShowCard(true);
            } else {
              setIsExpired(true);
              if (localHasIncident) {
                setShowCard(false);
              } else {
                setShowCard(true);
              }
            }

          } else {
            const diffInMs = expD - now;
            const days = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

            setDaysLeft(days);
            setIsExpired(false);
            localIsExpired = false;
          }
        }

        localStorage.setItem("isExpired", localIsExpired);

        const adminStatus = profile.isAdmin || false;
        setIsAdmin(adminStatus);

        const barAdminStatus = profile.isBarAdmin || false;
        setIsBarAdmin(barAdminStatus);
      }
      spinner(false);
    } catch (error) {
      console.error("Profile Query Error:", error);
      setUserProfile(false);
      setIsAdmin(false);
      setIsBarAdmin(false);
      spinner(false);
    }
  };

  const handleLogout = () => {
    spinner(true)
    signOut(auth).then(() => {
      setUserProfile(false)
      setXState(xState + 1);
      spinner(false)
      window.location.reload();
    }).catch((error) => {
      spinner(false)
    });
  }

  const handleChildLogin = (data) => {
    if (data === "Register") {
      setShowRegister(true)
      setShow(false)
    } else {
      setShow(false)
      setXState(xState + 1);
    }
  };

  const handleChildProfileUpdate = () => {
    spinner(true)
    setXState(xState + 1);
    spinner(false)
  }

  const handleChildAccessClub = () => {
    handleParentAccessLogChange()
    spinner(true)
    setXState(xState + 1);
    spinner(false)
  }

  const handleChildRegister = (data) => {
    if (data === "UserX") {
      setShow(true)
      setShowRegister(false)
    } else {
      setShowRegister(false)
      setShow(false)
      setXState(xState + 1);
      getProfileDoc()
    }
  };

  return (
    <div>
      <div id="spinIt"></div>
      <div>
        <Navbar expand="lg" className='navDark custom-mobile-nav'>
          <Container fluid className="position-relative d-flex align-items-center justify-content-between">
            <Navbar.Brand className="m-0">
              <div className="apc padding animated rollIn modified-apc">APC</div>
            </Navbar.Brand>

            {/* THE CENTRAL MOBILE TRACK CONTROLLER ENGINE */}
            <div className="mobile-center-header-zone d-inline-flex d-lg-none">
              {/* CHECK MARK NOTIFICATION: Visible if user holds an active log inside operational shift frame */}
              {userProfile && !accountFlag && accessItems && accessItems.length > 0 && !accessItems[0]?.checkedOutAt ? (
                <div className="mobile-top-vitals">
                  <AccessVitals 
                    memberEmail={localStorage.getItem("email")} 
                    refreshTrigger={refreshKey} 
                    activeLog={accessItems[0]} 
                  />
                </div>
              ) : ""}

              {/* ACTION LAYOUT ENGINE */}
              {userProfile && isMember && !isExpired && !accountFlag && !hasIncident ? (
                <div className="club-access-menu-item mobile-top-bar-qr">
                  <LocationDistanceCalculator
                    setDistanceToClub={setDistanceToClub}
                    accessItems={accessItems}
                    userProfile={userProfile}
                    handleChildAccessClub={handleChildAccessClub}
                  />
                </div>
              ) : ""}

              {/* STATE 3: Completely Logged Out -> Show inline Login button trigger */}
              {localStorage.getItem('email') === "Login" && (
                <div className="mobile-action-bar">
                  <Button onClick={() => setShow(true)} className="mobile-login-trigger">
                    <img src={thumb} alt="login icon" className="thumb" /><br></br>
                    <span>Login</span>
                  </Button>
                </div>
              )}
            </div>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className=" justify-content-left flex-grow-1 ">
              </Nav>
              <Nav className="desktop-nav-items">

                {/* DESKTOP ACTION CONTAINER */}
                {userProfile && isMember && !isExpired && !accountFlag && !hasIncident ? (
                  <div className="club-access-menu-item d-none d-lg-inline-flex">
                    <LocationDistanceCalculator
                      setDistanceToClub={setDistanceToClub}
                      accessItems={accessItems}
                      userProfile={userProfile}
                      handleChildAccessClub={handleChildAccessClub}
                    />
                  </div>
                ) : ""}

                {/* DESKTOP CHECK MARK NOTIFICATION */}
                {userProfile && !accountFlag && accessItems && accessItems.length > 0 && !accessItems[0]?.checkedOutAt ? (
                  <div className="d-none d-lg-inline-flex">
                    <AccessVitals 
                      memberEmail={localStorage.getItem("email")} 
                      refreshTrigger={refreshKey}
                      activeLog={accessItems[0]}
                    />
                  </div>
                ) : ""}

                {localStorage.getItem('email') == "Login" ?
                  <Button onClick={() => setShow(true)} className="desktop-only-auth-btn">
                    <img
                      src={thumb}
                      alt="login icon"
                      className="thumb hoverX animated fadeInRight"
                    />  <br></br>
                    <span className="">Login</span>
                  </Button>
                  :
                  <div className="navbar-authorized-actions">
                    <Button onClick={handleLogout}>
                      <img
                        src={thumb2}
                        alt="logout icon"
                        className="thumb hoverX animated fadeInRight"
                      />  <br></br>
                      <span className=""> Logout</span>
                    </Button>

                    {profileItems.map(x => (
                      <UpdateProfile
                        isTriggerOnly={false}
                        idx={x.id}
                        theme={theme}
                        key={x.id}
                        hide={true}
                        name={x.name}
                        type={x.type}
                        filex={x.filex}
                        onSendToParent={handleChildProfileUpdate}
                        className=""></UpdateProfile>
                    ))}

                    {userProfile && !accountFlag && (isExpired || daysLeft < 40) && !hasIncident ?
                      <Button onClick={() => setShowCard(true)}>
                        <img
                          src={target}
                          alt={isExpired ? "Expired" : "Warning"}
                          className="thumb hoverX  expired-image"
                        />  <br></br>

                        {isExpired ? (
                          "Expired"
                        ) : daysLeft > 0 ? (
                          <span className="">Expires in {daysLeft} days </span>
                        ) : "Attention!"}
                      </Button>
                      :
                      ""
                    }

                    {userProfile && hasIncident ?
                      <Incidentz
                        theme={theme}
                        public={true}
                        userEmail={localStorage.getItem('email')}
                      />
                      : ""}

                    {userProfile && !isExpired && !accountFlag && !hasIncident && isMember ?
                      <XDocz public={true} theme={theme}></XDocz>
                      : ""}

                    {userProfile && !isExpired && !accountFlag && !hasIncident && isMember ?
                      <XMenu public={true} theme={theme}></XMenu>
                      : ""}

                    {isAdmin && userProfile ?
                      <Admin></Admin>
                      : ""}

                    {isBarAdmin && userProfile && distanceToClub <= clubTargetRange ?
                      <BarAdmin></BarAdmin>
                      : ""}

                    {theme === 'dark' ?
                      <Button onClick={toggleTheme}>
                        <img
                          src={sun}
                          alt="Change to light mode"
                          className="thumb hoverX animated fadeInRight"
                        /><br></br> Mode
                      </Button>
                      : <Button onClick={toggleTheme}>
                        <img
                          src={moon}
                          alt="Change to dark mode"
                          className="thumb hoverX animated fadeInRight"
                        /><br></br> Mode
                      </Button>
                    }
                  </div>
                }
              </Nav>
              <Nav id="end" className="white justify-content-end flex-grow-1 pe-4 ">
                <div className="status-container">
                  <div className="status-item">
                    <span className={`dot ${isMember ? 'success' : 'inactive'}`}></span>
                    Member: {isMember ? 'Yes' : 'No'}
                  </div>

                  {hasIncident && (
                    <div className="status-item">
                      <span className={`dot ${hasIncident ? 'danger' : 'inactive'}`}></span>
                      Incident: {hasIncident ? 'Yes' : 'No'}
                    </div>
                  )}

                  {accountFlag && (
                    <div className="status-item">
                      <span className={`dot ${accountFlag ? 'warning' : 'inactive'}`}></span>
                      Flagged: {accountFlag ? 'Yes' : 'No'}
                    </div>
                  )}

                  {isExpired && (
                    <div className="status-item">
                      <span className={`dot ${isExpired ? 'danger' : 'inactive'}`}></span>
                      Expired: {isExpired ? 'Yes' : 'No'}
                    </div>
                  )}
                  {isAdmin && (
                    <div className="status-item admin-row">
                      <span className="dot admin"></span>
                      Admin: Yes
                    </div>
                  )}

                  {isBarAdmin && (
                    <div className="status-item">
                      <span className={`dot ${isBarAdmin ? 'success' : 'inactive'}`}></span>
                      Scanner: {isBarAdmin ? 'Yes' : 'No'}
                    </div>
                  )}
                </div>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

      <div className={theme === 'dark' ? "bg-dark" : ""} style={{ 'marginTop': '-20px' }}>

        <Modal
          show={showCard}
          onHide={() => setShowCard(false)}
          dialogClassName="md-down"
          backdropClassName={theme === 'dark' ? "adminBackdrop" : "docLight"}
          contentClassName={theme === 'dark' ? "" : "glassWhite"}
          aria-labelledby="Process Membership"
        >
          <Modal.Body>
            <QuickPayment
              theme={theme}
              userUid={localStorage.getItem('uid')}
              userName={localStorage.getItem('user')}
              userEmail={localStorage.getItem('email')}
              typeOfMembership={localStorage.getItem('type')}
              daysLeft={daysLeft}
              expired={isExpired}
              expirationDate={localStorage.getItem('expirationDate')}
              lateFee={lateFee}
              amount={amount}
              onClose={() => setShowCard(false)}
            />
          </Modal.Body>
        </Modal>

        <div id="idx"></div>

        <div className="main">
          <span className="padding"> <h1 className={theme === 'dark' ? "apc-text text-light animated fadeInLeft" : "apc-text text-dark animated fadeInLeft"}>Albuquerque Press Club</h1>
            <span style={{ fontSize: '2.5vh' }}>
              promotes fellowship and understanding among people engaged in journalism and its allied fields, sponsors cultural, educational and social activities that promote good fellowship and
              professional growth among members, and extends reciprocity to similar clubs in other parts of the nation and world.
            </span>
          </span>

          <div className="App dark-theme-bg">

          </div>
        </div>
        <About theme={theme}></About>
        {userProfile && !isExpired && !accountFlag && !hasIncident && isMember ?
          <InteractiveVideo userEmail={localStorage.getItem("email")} />
          : ""}
        <div className="p-2 mx-2">
          <EventSuite
            theme={theme}
            currentUser={user}
            isAdmin={false}
          />
        </div>
        <div >
          <div className={BGCal}>
            <div className="flex-container-main calx paddingXL centerIt">
              <OptimizedCalendarSection />
              <hr></hr>
            </div>
          </div>
        </div>

        <div className={` borderx ${theme === 'dark' ? 'bg-dark' : 'bg-light'}`} >  <XArtist></XArtist></div><br></br>
        <div className={` bordery padding ${theme === 'dark' ? 'bg-dark' : ''}`}  >
          <div className="container-fluid" >
            <div className="row g-3">
              <div className="col-12 col-lg-3">
                <XLinkz theme={theme} />
              </div>
              <div className="col-12 col-lg-3 m-0 ">
                <XVideoz></XVideoz>
              </div>
              <div className="col-12 col-lg-3">
                <h4 className="orange">
                  Rep your favorite house on the hill!</h4>
                <div className={`container-fluid ${theme === 'dark' ? 'glassBlack' : ''}`}>
                  <div style={{ 'fontSize': '1.2rem' }} className="text-muted padding">
                    We have zip hoodies, baseball shirts, two different t-shirt designs, mugs, lighters. <br></br>Also we have gift cards on top of gifting a membership to a friend – just ask your bartender.
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-3 px-4 py-1 rounded clubx" style={{ 'minHeight': '250px' }}>
              </div>
            </div>
          </div>
        </div>
      </div>
      <>

        <Modal size="sm" show={showQR} onHide={handleCloseQR} contentClassName="bg-light-profile" backdropClassName="adminBackdrop" centered>
          <Modal.Header closeButton>
            <Modal.Title><strong><span className="badge rounded-pill bg-primary"> QR CODE</span></strong></Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex flex-column align-items-center justify-content-center text-center p-4 ">
            <strong className=" arrow_box_bottom">Member - <span className="orange">{localStorage.getItem("user")}</span><br></br> Present to staff for club access...</strong><br></br><br></br>
            <div className="image-focus-wrapper hoverX"><br></br>
              <QRCode value={localStorage.getItem("email") || "none"} bgColor="white" fgColor={"#070000"} size={150} /></div><br></br><br></br>
          </Modal.Body>
        </Modal>
      </>
      <>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          dialogClassName="md-down"
          backdropClassName={theme === 'dark' ? "adminBackdrop" : "docLight"}
          contentClassName={theme === 'dark' ? "" : "bg-dark"}
          aria-labelledby="LogIn screen"
        >
          <Modal.Body>
            <Login onSendToParent={handleChildLogin}></Login>
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="outline-warning" onClick={() => setShow(false)} className="px-4">
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>

      <>
        <Modal
          show={showRegister}
          onHide={() => setShowRegister(false)}
          dialogClassName="md-down"
          aria-labelledby="Register screen"
          backdropClassName={theme === 'dark' ? "adminBackdrop" : "docLight"}
          contentClassName={theme === 'dark' ? "" : "bg-dark"}
        >
          <Modal.Body>
            <SignUp onSendToParent={handleChildRegister}></SignUp>
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="outline-warning" onClick={() => setShowRegister(false)} className="px-4">
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>

      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />

      {isVisible && (
        <div className="scroll-to-top-arrow" onClick={scrollToTop}>
          <FaArrowUp style={{ display: isVisible ? 'block' : 'none' }} />
        </div>)}

      <footer className="blacx">
        <Address distance={distanceToClub} /><br></br>
      </footer>
    </div >
  );
}